import { basicBatchData } from "../../../data/batchData";
import { validMainData } from "../../../data/mainData";
import { validAppearance, validLabels } from "../../../data/pallet-steps";
import { useTypedSelector } from "../../../hooks/useTypedSelector"
import { AccordionCard } from '../../cards/AccordionCard';
import { CustomFields } from "./CustomFields";
import { CustomFieldsDefect } from "./CustomFieldsDefect";

export interface CustomFieldsProps {
    property: "mainData" | "labels" | "appearance" | "pallgrow"
    label: "Main Data" | "Labels" | "Appearance" | "Pall/Grower"
    checkedItems: string[]
    validItems: string[]
    personalItems?: string[]
}
export const SettingsCustoms = () => {

    const { settings } = useTypedSelector(state => state.auth);

    const mainData = settings?.custom_fields.mainData || Object.keys(basicBatchData)
    const labels = settings?.custom_fields.labels || validLabels
    const appearance = settings?.custom_fields.appearance || validAppearance
    const pallgrowMajor = settings?.custom_fields?.pallgrow?.major || []
    const pallgrowMinor = settings?.custom_fields?.pallgrow?.minor || []

    const personalLabels = settings?.custom_fields.personal?.labels || []
    const personalAppearance = settings?.custom_fields.personal?.appearance || []
    const personalPallgrowMajor = settings?.custom_fields.personal?.pallgrow?.major || []
    const personalPallgrowMinor = settings?.custom_fields.personal?.pallgrow?.minor || []

    const customFields: CustomFieldsProps[] = [
        {
            property: "mainData",
            label: "Main Data",
            checkedItems: mainData,
            validItems: validMainData
        },
        {
            property: "labels",
            label: "Labels",
            checkedItems: labels,
            validItems: validLabels,
            personalItems: personalLabels
        },
        {
            property: "appearance",
            label: "Appearance",
            checkedItems: appearance,
            validItems: validAppearance,
            personalItems: personalAppearance
        },
    ]

    return (
        <div>
            <h3 className="tw-mb-2">Custom Fields</h3>

            <div className="tw-space-y-2">
                {
                    customFields.map((field, index) => (
                        <AccordionCard key={field.property + index} title={field.label} defaultOpen={false} className="tw-rounded-2xl">
                            <CustomFields field={field} />
                        </AccordionCard>
                    ))
                }

                <AccordionCard title="Pall/Grower" defaultOpen={false} className="tw-rounded-2xl">
                    <CustomFieldsDefect
                        pallgrowMinor={pallgrowMinor}
                        pallgrowMajor={pallgrowMajor}
                        personalPallgrowMinor={personalPallgrowMinor}
                        personalPallgrowMajor={personalPallgrowMajor}
                    />
                </AccordionCard>

            </div>
        </div>
    )
}
